const RESOURCES_TYPES: ResourceType[] = [
  {
    title: 'Solo texto',
    value: 'TEXT',
  },
  {
    title: 'Audio',
    value: 'AUDIO',
  },
];
export interface ResourceType {
  title: string;
  value: string;
}
export default RESOURCES_TYPES;
